import { baseApiUrl, domainName } from '@/utils/common/env.constants';
import { EnquiryData, IEnquiryResponse } from '@/interfaces/contactUs';
import { domainNameEnums, saasDomains } from '@/utils/Domain';
import { saasDomainprefixUrl, skillsDomainprefixUrl } from '@/utils/Configuration/utils';
import { post } from './index';

const prefixUrl = saasDomains.includes(domainName as domainNameEnums)
  ? saasDomainprefixUrl
  : skillsDomainprefixUrl;
class ContactUsApi {
  static async sendEnquiry(data: EnquiryData, token: string) {
    return post<IEnquiryResponse>(`${baseApiUrl}/${prefixUrl}/public/user/enquiry`, {
      ...data,
      'g-recaptcha-response': token,
    });
  }
}

export default ContactUsApi;
